import { render, staticRenderFns } from "./TodoCard.vue?vue&type=template&id=4465e750&scoped=true&"
var script = {}
import style0 from "./TodoCard.vue?vue&type=style&index=0&id=4465e750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465e750",
  null
  
)

export default component.exports